import {
  CircledIcon,
  PageContainer,
  PageFooter,
  SimpleStepDots,
  StepProps,
} from '../../../shared_components';
import { useTranslation } from 'react-i18next';
import { Flex, Stack, Title, Text, Space } from '@mantine/core';
import EastIcon from '@mui/icons-material/East';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { Link } from 'react-router-dom';
import classes from '../../../app.module.css';
import { useUserDataStore } from '../../../shared_stores';

export const StepEmailVerification = ({
  forward,
  back,
  step = 0,
  max = 0,
}: StepProps) => {
  const { t } = useTranslation(['registration', 'common']);
  const userDataStore = useUserDataStore();
  return (
    <PageContainer>
      <Flex direction={'column'} justify={'space-between'} h={'100%'}>
        <Stack classNames={{ root: classes.footerPadding }}>
          <SimpleStepDots step={step} max={max} text={false} />
          <CircledIcon icon={<ForwardToInboxIcon sx={{ fontSize: 48 }} />} />
          <Title style={{ textAlign: 'center' }} order={2}>
            {t('email_verification_title')}
          </Title>
          <Text style={{ textAlign: 'center' }}>
            {t('registration:email_verification_message_1')}
            {userDataStore.emailAndConsents?.email}
            {t('registration:email_verification_message_2')}
          </Text>
          <Space h={'var(--mantine-spacing-md)'} />
          <Stack gap={0}>
            <Text style={{ textAlign: 'center' }}>
              {t('email_verification_question')}
            </Text>
            <Link style={{ textAlign: 'center' }} to={'/'}>
              {t('send_again')}
            </Link>
          </Stack>
        </Stack>
        <PageFooter
          leftOnClick={back}
          buttonText={t('continue')}
          buttonIcon={<EastIcon />}
          disabled
        />
      </Flex>
    </PageContainer>
  );
};
